export default "const arr = [\n      \"a\", \"b\",\n \"c\",\n     \"d\",\n];\n"